import { createStore, applyMiddleware, Middleware } from 'redux'
import createSagaMiddleware from 'redux-saga'
import reducer from './reducers/index'
import saga from './sagas'
import logger from 'redux-logger'

export default function configureStore(initialState = {}) {
  const sagaMiddleware = createSagaMiddleware()
  let middlewares: Middleware[] = [sagaMiddleware]
  if (process.env.NODE_ENV === `development`) {
    middlewares.push(logger)
  }
  const store = createStore(
    reducer,
    initialState,
    applyMiddleware(...middlewares)
  )
  sagaMiddleware.run(saga)
  return store
}
